// extracted by css-extract-rspack-plugin
export default {"UserAvatar":"HZAYqTgJUsoo2jAg","Name":"LQdF6yvVOGcDpSr6","Email":"_8XsXaOAewtlrbOL"};